

import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[mwc-menu-divider]',
  exportAs: 'mwcMenuDivider',
  host: {
    class: 'mwc-dropdown-menu-item-divider'
  }
})
export class MwcMenuDividerDirective {
  constructor(public elementRef: ElementRef) {}
}
